export const ROOT_URL_ANONYMOUS =
  'https://thobe-08c2be79abe1.herokuapp.com/api/anonymous';
export const ROOT_URL_PROTECTED =
  'https://thobe-08c2be79abe1.herokuapp.com/api/protected';
